var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Icon } from '@citrus/icon';
import { TrendLargeWrapper, TrendSmallWrapper, TrendLarge, TrendSmall } from './ProgressBar.styled';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import { getTrendColor } from './private/_utils';
import { useTheme } from '@citrus/user';
var VERSION = '4.6.0';
var Trend = function (_a) {
    var _b;
    var automationId = _a.automationId, className = _a.className, color = _a.color, css = _a.css, direction = _a.direction, _c = _a.small, small = _c === void 0 ? false : _c, value = _a.value, _d = _a.__TYPE, TYPE = _d === void 0 ? 'Trend' : _d, other = __rest(_a, ["automationId", "className", "color", "css", "direction", "small", "value", "__TYPE"]);
    var debug = useCitrusDebug();
    var itemRef = useRef(null);
    var isCitron = useTheme().citrus2022;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var icons = new Map([
        ['up', 'arrow-up'],
        ['down', 'arrow-down'],
        ['neutral', 'minus'],
    ]);
    var displayValue = typeof value === 'number' ? "".concat(value, "%") : value;
    var TrendContent = small ? TrendSmall : TrendLarge;
    var Component = small ? TrendSmallWrapper : TrendLargeWrapper;
    return (React.createElement(Component, __assign({ className: classes, ref: itemRef }, other, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
        React.createElement("span", { style: { color: getTrendColor(color, isCitron) } },
            React.createElement(Icon, { bold: true, name: icons.get(direction), size: "xsmall", title: direction })),
        React.createElement(TrendContent, null, displayValue)));
};
Trend.defaultProps = {
    __TYPE: 'Trend',
};
export default Trend;
